<div [ngClass]="{ dark: this.themeService.isDark }">
  <router-outlet></router-outlet>
  <!-- <app-responsive-helper></app-responsive-helper> -->
</div>
<error-build></error-build>
